import * as React from 'react';
import { CommonActions, DrawerActions, useLinkBuilder } from '@react-navigation/native';
import { DrawerItem } from '@react-navigation/drawer';
import { Screens, Modals, Stacks } from '../constants/ScreenNames';
import { useTranslation } from 'react-i18next';
import Icon from '../components/Icon';
import { AA_ENABLED, EVENTS_ENABLED, CREW_ENABLED } from '../config/env';

const CustomDrawerItemList = ({
  state,
  navigation,
  descriptors,
  activeTintColor,
  inactiveTintColor,
  activeBackgroundColor,
  inactiveBackgroundColor,
  itemStyle,
  labelStyle,
  user,
}) => {
  const { t } = useTranslation();
  const buildLink = useLinkBuilder();
  let bottomTabIndex = '';
  return (
    <>
      {state.routes.map((route, i) => {
        let focused = false;
        if (!user) {
          focused = i === state.index;
        } else {
          // for first tab we need to check tab navigator index and manually mark the outter loop tabs focused
          if (i === 0 && state.index === 0) {
            bottomTabIndex = route?.state?.index;
            // first bottomTabIndex is the first drawer item as well
            focused = state.index === 0 && bottomTabIndex === 0;
          } else {
            focused = i === state.index;
          }
        }
        const { title, drawerLabel, drawerIcon } = descriptors[route.key].options;
        const getHomeScreen = function () {
          if (EVENTS_ENABLED) {
            return Screens.EventHome;
          } else if (AA_ENABLED) {
            return Screens.AASearchScreen;
          } else {
            return Screens.Home;
          }
        };
        return (
          <DrawerItem
            key={route.key}
            label={
              drawerLabel !== undefined ? drawerLabel : title !== undefined ? title : route.name
            }
            icon={drawerIcon}
            focused={focused}
            activeTintColor={activeTintColor}
            inactiveTintColor={inactiveTintColor}
            activeBackgroundColor={activeBackgroundColor}
            inactiveBackgroundColor={inactiveBackgroundColor}
            labelStyle={labelStyle}
            style={itemStyle}
            to={buildLink(route.name, route.params)}
            onPress={() => {
              i === 0
                ? navigation.navigate(getHomeScreen())
                : navigation.dispatch({
                    ...(focused ? DrawerActions.closeDrawer() : CommonActions.navigate(route.name)),
                    target: state.key,
                  });
            }}
          />
        );
      })}
      {user && !AA_ENABLED ? (
        <>
          <DrawerItem
            label={t('CustomDrawerItemList.Trips')}
            labelStyle={labelStyle}
            focused={bottomTabIndex === 1}
            activeTintColor={activeTintColor}
            inactiveTintColor={inactiveTintColor}
            icon={({ color }) => <Icon name="bag" color={color} size={24} />}
            //onPress={() => navigation.navigate(Screens.MyTrips)}
            onPress={() => {
              bottomTabIndex === 1
                ? navigation.closeDrawer()
                : navigation.navigate(Stacks.MytripsStack, { screen: Screens.MyTrips });
              //   navigation.dispatch({
              //     ...(bottomTabIndex === 1
              //       ? DrawerActions.closeDrawer()
              //       : CommonActions.navigate(Screens.MyTrips)),
              //     target: state.key,
              //   });
            }}
          />
          {!CREW_ENABLED && (
            <DrawerItem
              label={t('CustomDrawerItemList.Me')}
              focused={bottomTabIndex === 3}
              activeTintColor={activeTintColor}
              inactiveTintColor={inactiveTintColor}
              labelStyle={labelStyle}
              icon={({ color }) => <Icon name="person" color={color} size={24} />}
              //onPress={() => navigation.navigate(Screens.Me)}
              onPress={() => {
                bottomTabIndex === 3
                  ? navigation.closeDrawer()
                  : navigation.navigate(Stacks.MeStack, { screen: Screens.Me });
                //   navigation.dispatch({
                //     ...(bottomTabIndex === 2
                //       ? DrawerActions.closeDrawer()
                //       : CommonActions.navigate(Screens.Me)),
                //     target: state.key,
                //   });
              }}
            />
          )}
          <DrawerItem
            label={t('CustomDrawerItemList.Agent')}
            icon={({ color }) => <Icon name="agent" color={color} size={24} />}
            activeTintColor={activeTintColor}
            inactiveTintColor={inactiveTintColor}
            labelStyle={labelStyle}
            onPress={() => navigation.navigate(Modals.AgentContact)}
          />
        </>
      ) : null}

      {AA_ENABLED || EVENTS_ENABLED ? (
        <>
          {AA_ENABLED && (
            <DrawerItem
              label={t('MainNavigator.HomeDrawerTitle')}
              icon={({ color }) => <Icon name="building" color={color} size={24} />}
              activeTintColor={activeTintColor}
              inactiveTintColor={inactiveTintColor}
              labelStyle={labelStyle}
              onPress={() => navigation.navigate(Screens.AAHome)}
            />
          )}
          <DrawerItem
            label={t('CustomDrawerItemList.Agent')}
            icon={({ color }) => <Icon name="agent" color={color} size={24} />}
            activeTintColor={activeTintColor}
            inactiveTintColor={inactiveTintColor}
            labelStyle={labelStyle}
            onPress={() => navigation.navigate(Modals.AgentContact)}
          />

          {user ? (
            <>
              <DrawerItem
                label={t('CustomDrawerItemList.Trips')}
                labelStyle={labelStyle}
                focused={bottomTabIndex === 3}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                icon={({ color }) => <Icon name="bag" color={color} size={24} />}
                onPress={() =>
                  navigation.navigate(Stacks.MytripsStack, { screen: Screens.MyTrips })
                }
              />

              <DrawerItem
                label={t('CustomDrawerItemList.Me')}
                focused={bottomTabIndex === 4}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                icon={({ color }) => <Icon name="person" color={color} size={24} />}
                onPress={() => navigation.navigate(Stacks.MeStack, { screen: Screens.Me })}
              />

              <DrawerItem
                label={t('MainNavigator.SettingsDrawerTitle')}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                icon={({ color }) => <Icon name="settings" color={color} size={24} />}
                onPress={() =>
                  navigation.navigate(Stacks.SettingsStack, { screen: Screens.Settings })
                }
              />
            </>
          ) : (
            <>
              <DrawerItem
                label={t('MainStackNavigator.TermsOfUse')}
                icon={({ color }) => <Icon name="passport" color={color} size={24} />}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                onPress={() => navigation.navigate(Screens.TermsOfUse)}
              />
              <DrawerItem
                label={t('MainStackNavigator.PrivacyPolicy')}
                icon={({ color }) => <Icon name="passport" color={color} size={24} />}
                activeTintColor={activeTintColor}
                inactiveTintColor={inactiveTintColor}
                labelStyle={labelStyle}
                onPress={() => navigation.navigate(Screens.PrivacyPolicy)}
              />
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default CustomDrawerItemList;
